var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { connect } from 'react-redux';
import * as actions from '../../actions';
import VentanaCaducidad from '../components/ventana-caducidad';
import { getCaducado } from '../../selectors';
import * as Util from '../../util';
var VentanaCaducidadContainer = connect(function (state) {
  var _getCaducado = getCaducado(state),
      caducado = _getCaducado.caducado,
      msg = _getCaducado.msg;

  return {
    caducado: caducado,
    msg: msg
  };
}, function (dispatch) {
  return {
    // onKs: () => {
    //     // dispatch(actions.setCaducado(false))
    //     // dispatch(actions.pantalla(PANTALLA_PORTADA_ID))
    //     dispatch(actions.setCaducado(false, ''))
    // },
    onCerrar: function onCerrar() {
      var marca = Util.getStorageData('mua');
      Util.setStorageData('mua', _extends({}, marca, {
        mostrado: true
      }));
      dispatch(actions.setCaducado(false, ''));
    }
  };
})(VentanaCaducidad);
export default VentanaCaducidadContainer;